module.exports = __webpack_public_path__ + "img/masseyferguson_thumbnail.66f2a000.png";